import React from 'react';
import { useMsal } from '@azure/msal-react';
import BookingSummary from 'Components/BookingSummary/BookingSummary';
import Button from 'Components/Button';
import { depositAmount} from 'Components/Constants';
import { getDaysArray} from 'Components/Functions';
import { setCurrentBooking } from 'features/Booking-Slice';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from 'store';
import styled from 'styled-components';
import { BookingAPI } from 'API/BookingAPI';

type SummaryContainerProps = {
    disableSubmitBtn: boolean;
}
const Container = styled.div`
    padding-top: 30px;
    width: 100%;
    @media (min-width: 800px) {
        width: 20%;
    }
`;
function SummaryContainer({ disableSubmitBtn }: SummaryContainerProps) {
    const { currentBooking  } = useSelector((state: RootState) => state.booking);
    const { currentEmployee  } = useSelector((state: RootState) => state.auth);
    const discountPercentage = currentEmployee ? currentEmployee.discount_percentage * 100 : 0;
    const dispatch = useDispatch();
    const { instance } = useMsal();
    const navigate = useNavigate();

    var weeksAway = 0;

    const selectedDates = getDaysArray(currentBooking?.start_date.split("T")[0] ?? "", currentBooking?.end_date.split("T")[0] ?? "");

    if (selectedDates.length > 0) {
        var collection = moment(selectedDates[0]);
        var today = moment().format("YYYY-MM-DD");
        weeksAway = collection.diff(today, 'days') / 7;
    }
    
    const setDepositAmount = () => {
        const booking: any = {...currentBooking};
        booking.total_cost = depositAmount;
        dispatch(setCurrentBooking(booking));
    }

    const cancelBookingHandler = async() => {
        await BookingAPI.cancel(instance, currentBooking?.booking_id ?? 0);
        dispatch(setCurrentBooking(null));
        navigate("/");
    }
    return (
        <Container>
            <BookingSummary selectedDates={selectedDates} totalCost={currentBooking?.total_cost ?? 0}/>
            <div>
                <Button 
                    type={"submit"} 
                    name={"full"} 
                    colour={"dark"} 
                    width={"90%"} 
                    text={discountPercentage == 100 && currentBooking?.total_cost == 0 ? "confirm booking" : "pay in full"} 
                    disabled={disableSubmitBtn}
                />
                {discountPercentage !== 100 && 
                    <Button 
                        type={"submit"} 
                        name={"deposit"} 
                        colour={"dark"} 
                        width={"90%"} 
                        text={"pay a deposit now (£100.00) and the rest later"} 
                        onClick={setDepositAmount} 
                        disabled={disableSubmitBtn || weeksAway < 4} 
                    />
                }
                <Button 
                    type={"button"} 
                    text={"cancel booking"} 
                    colour={"light"} 
                    width={"90%"} 
                    disabled={!currentBooking?.booking_id} 
                    onClick={cancelBookingHandler}
                />
            </div>
        </Container>
    );
}
export default SummaryContainer;